import React from "react";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import FormatIndentIncreaseIcon from "@material-ui/icons/FormatIndentIncrease";

import { CustomSpeedDial, SpeedDialContainer } from "./styles/SpeedDialErp";

export default function SpeedDialErp({
  actions = [], // array de objetos com informações das ações: [{
  //   icon: <EditOutlinedIcon />,
  //   name: "Editar",
  //   action: funcaoASerExecutada,
  // }]
  style = {},
  direction = "right", // 'down', 'left', 'up'
  icon, // ícone do botão principal
  ...props
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (!actions.length) return alert("Defina as ações do Speed Dial!");

  return (
    <SpeedDialContainer>
      <CustomSpeedDial
        ariaLabel="SpeedDial tooltip example"
        icon={icon ?? <FormatIndentIncreaseIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction={direction}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.action}
            disabled={action.disabled}
          />
        ))}
      </CustomSpeedDial>
    </SpeedDialContainer>
  );
}
